import { render, staticRenderFns } from "./comtotalCust.vue?vue&type=template&id=0c7d99cc&scoped=true&"
import script from "./comtotalCust.vue?vue&type=script&lang=js&"
export * from "./comtotalCust.vue?vue&type=script&lang=js&"
import style0 from "./comtotalCust.vue?vue&type=style&index=0&id=0c7d99cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7d99cc",
  null
  
)

export default component.exports